// LAYOUT
import '../layout.js';

// SWIPER
import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs } from 'swiper/modules';

// BOOTSTRAP
import Accordion from 'bootstrap/js/dist/collapse';

// GSAP
import { gsap , ScrollSmoother , ScrollTrigger } from "../layout.js";
import { gsapSmoothScrollObj } from "../layout.js";

var swiper = new Swiper(".timeline-swiper-thumb", {
	modules: [Navigation, Thumbs],
	slidesPerView: 4,
	spaceBetween: 10,
	freeMode: true,
	watchSlidesProgress: true,
	centeredSlides: true,
	direction: "horizontal",
	breakpoints: {
		992: {
			direction: "vertical",
			slidesPerView: 4,
		},
		768: {
			slidesPerView: 8,
		}
	},
	navigation: {
		nextEl: ".timeline .swiper-button-next",
		prevEl: ".timeline .swiper-button-prev",
	},
});
var swiper2 = new Swiper(".timeline-swiper", {
	modules: [Navigation, Thumbs],
	thumbs: {
		swiper: swiper,
	},
	navigation: {
		nextEl: ".timeline .swiper-button-next",
		prevEl: ".timeline .swiper-button-prev",
	},
	breakpoints: {
		992: {
			direction: "vertical",
		}
	}
});